export default __webpack_public_path__ + "static/logo-b112d0b0f7d7d6a6b60eab29a71305f6.svg";